import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/analytics`;

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('analytics_session_id', sessionId);
    sessionStorage.setItem('session_start', Date.now().toString());
  }
  return sessionId;
};

// Track pageview
export const trackPageView = async (pageUrl, pageTitle) => {
  try {
    const sessionId = getSessionId();
    const loadSpeed = performance.timing.loadEventEnd - performance.timing.navigationStart;
    
    await axios.post(`${API}/track`, {
      event_type: 'pageview',
      page_url: pageUrl,
      page_title: pageTitle,
      referrer: document.referrer,
      session_id: sessionId,
      page_load_speed: loadSpeed
    });
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};

// Track click
export const trackClick = async (element, text) => {
  try {
    const sessionId = getSessionId();
    
    await axios.post(`${API}/track`, {
      event_type: 'click',
      page_url: window.location.href,
      click_element: element,
      click_text: text,
      session_id: sessionId
    });
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};

// Track session end
export const trackSessionEnd = async () => {
  try {
    const sessionId = sessionStorage.getItem('analytics_session_id');
    const sessionStart = parseInt(sessionStorage.getItem('session_start'));
    const sessionDuration = Math.floor((Date.now() - sessionStart) / 1000); // in seconds
    
    if (sessionId) {
      await axios.post(`${API}/track`, {
        event_type: 'session_end',
        session_id: sessionId,
        session_duration: sessionDuration
      });
    }
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};

// Initialize analytics tracking
export const initAnalytics = () => {
  // Track initial pageview
  trackPageView(window.location.href, document.title);
  
  // Track session end on page unload
  window.addEventListener('beforeunload', trackSessionEnd);
  
  // Track clicks on important elements
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (target.tagName === 'BUTTON' || target.tagName === 'A') {
      trackClick(target.tagName, target.innerText || target.textContent);
    }
  });
};